import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api.service';

@Injectable()
export class GinopHomeResolver implements Resolve<any> {
  constructor(
    private readonly apiService: ApiService,
    private readonly router: Router,
    private readonly translateService: TranslateService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const previewHash = route.queryParams['previewHash'];
    const request$ = previewHash ? this.apiService.getContentPreview$(previewHash) : this.apiService.getContentList$('GinopHomePage');
    return request$.pipe(catchError(() => this.router.navigate(['/', this.translateService.currentLang, '404'])));
  }
}
